import React from 'react';

import {
    AccessTime,
    AccountBox,
    AccountCircle,
    AdminPanelSettingsOutlined,
    Add,
    AddBox,
    AddComment,
    AdminPanelSettings,
    AddPhotoAlternate,
    Archive,
    ArrowBack,
    ArrowDropDown,
    ArrowForward,
    ArrowRight,
    Assignment,
    AssignmentOutlined,
    AssignmentInd,
    AssignmentIndOutlined,
    AssignmentLateOutlined,
    AssignmentReturnOutlined,
    AssignmentTurnedIn,
    AssignmentTurnedInOutlined,
    AttachFile,
    ArticleOutlined,
    Autorenew,
    Backspace,
    BarChart,
    BorderColorOutlined,
    Business,
    Call,
    CallOutlined,
    CallEnd,
    CallEndOutlined,
    CallMade,
    CallMerge,
    CallMissed,
    CallMissedOutgoing,
    CallReceived,
    CallToAction,
    Cancel,
    Chat,
    ChatOutlined,
    ChatBubble,
    Check,
    CheckBoxOutlineBlank,
    CheckCircle,
    CheckCircleOutline,
    ChevronLeft,
    ChevronRight,
    Close,
    CloudQueue,
    CloudUpload,
    Comment,
    Contacts,
    ControlPoint,
    Crop32,
    Dashboard,
    DeleteForever,
    DescriptionOutlined,
    Dialpad,
    Done,
    DragHandle,
    Edit,
    Equalizer,
    Error,
    ErrorOutline,
    Extension,
    FormatBold,
    FormatItalic,
    FormatListBulleted,
    FormatListNumbered,
    FormatUnderlined,
    Forum,
    Fullscreen,
    FullscreenExit,
    GetApp,
    WidgetsOutlined,
    Group,
    HeadsetMic,
    Hearing,
    History,
    HourglassFull,
    Image,
    Info,
    InfoOutlined,
    InsertDriveFile,
    InsertEmoticon,
    Launch,
    Link,
    Lock,
    LockOpen,
    LockOutlined,
    Loop,
    Mail,
    MailOutlined,
    MeetingRoom,
    Message,
    MessageOutlined,
    Mic,
    MicOutlined,
    MicOff,
    Minimize,
    MoreHoriz,
    MoreVert,
    Movie,
    NoMeetingRoom,
    NotInterested,
    NoteAdd,
    NoteAddOutlined,
    PostAddOutlined,
    Notifications,
    NotificationsActive,
    NotificationsNone,
    NotificationsOff,
    OpenInNew,
    Pause,
    PauseCircleOutline,
    PendingOutlined,
    People,
    PermContactCalendar,
    Person,
    PrivacyTipOutlined,
    PersonAdd,
    PersonOutline,
    Phone,
    PhoneCallback,
    PhoneInTalk,
    PictureInPictureAlt,
    PlayArrow,
    PlayCircleOutline,
    PresentToAll,
    PriorityHigh,
    RadioButtonUnchecked,
    RemoveRedEye,
    Replay,
    Reply,
    Report,
    ReportProblem,
    RingVolume,
    ScreenShare,
    ScreenShareOutlined,
    Search,
    Send,
    SentimentSatisfiedAlt,
    Settings,
    ShareOutlined,
    SettingsInputHdmi,
    SettingsPhone,
    ShowChart,
    SimCard,
    Smartphone,
    Star,
    StarBorder,
    Stop,
    Subject,
    SupervisedUserCircle,
    SupervisorAccount,
    SwapCalls,
    SwapHorizOutlined,
    Textsms,
    ThumbUp,
    ThumbUpOutlined,
    Timelapse,
    TimerOutlined,
    Today,
    Tonality,
    Tune,
    Unarchive,
    VideoCall,
    Videocam,
    VideocamOutlined,
    VideocamOff,
    Visibility,
    Voicemail,
    VolumeOff,
    VpnKey,
    WhatsApp,
    AutoAwesome,
} from '@mui/icons-material';

import Article from 'flow/components/icons/ArticleSvgs';
import AssignToMe from 'flow/components/icons/AssignToUserIcon';
import AssignToOther from 'flow/components/icons/AssignToOtherIcon';
import AutoFixWand from 'flow/components/icons/AutoFixWand';
import PendingIcon from 'flow/components/icons/PendingIcon';
import AddCall from 'flow/components/icons/AddCallIcon';
import Avg from 'flow/components/icons/AvgIcon';
import BackgroundReplace from 'flow/components/icons/BackgroundReplaceIcon';
import Bankid from 'flow/components/icons/BankidIcon';
import BottombarInverted from 'flow/components/icons/BottombarInvertedIcon';
import Copy from 'flow/components/icons/CopyIcon';
import CopyOutlined from 'flow/components/icons/CopyOutlinedIcon';
import FullscreenInverted from 'flow/components/icons/FullscreenInvertedIcon';
import Ivr from 'flow/components/icons/IvrIcon';
import LookUp from 'flow/components/icons/LookUpIcon';
import OmniQueue from 'flow/components/icons/OmniQueueIcon';
import OmniQueueInverted from 'flow/components/icons/OmniQueueInvertedIcon';
import Percent from 'flow/components/icons/PercentIcon';
import Post from 'flow/components/icons/PostIcon';
import QuickReply from 'flow/components/icons/QuickReplyIcon';
import Calls from 'flow/components/icons/RecordingIcon';
import RightPanel from 'flow/components/icons/RightPanelIcon';
import RightPanelInverted from 'flow/components/icons/RightPanelInvertedIcon';
import SupportAgent from 'flow/components/icons/SupportAgentIcon';
import Telavox from 'flow/components/icons/TelavoxIcon';
import TransferCall from 'flow/components/icons/TransferCallIcon';
import Widget from 'flow/components/icons/WidgetIcon';
import Frejaeid from 'flow/components/icons/FrejaeidIcon';
import Mitid from 'flow/components/icons/MitidIcon';
import { twMerge } from 'tailwind-merge';
import GoogleDriveIcon from 'flow/components/icons/GoogleDriveIcon';
import GoogleIcon from 'flow/components/icons/GoogleIcon';
import MicrosoftIcon from 'flow/components/icons/MicrosoftIcon';
import LeaveRoomIcon from 'flow/components/icons/LeaveRoomIcon';
import PushPinIcon from 'flow/components/icons/PushPinIcon';
import KeepOffIcon from 'flow/components/icons/KeepOffIcon';
import TextSnippet from 'flow/components/icons/TextSnippetIcon';
import AgentRemove from 'flow/components/icons/AgentRemoveIcon';
import Label from 'flow/components/icons/LabelIcon';
import Summarize from 'flow/components/icons/SummarizeIcon';
import {
    CheckboxChecked,
    CheckboxUnchecked,
} from 'flow/components/icons/CheckboxIcon';
import GppGood from 'flow/components/icons/GppGood';
import GoogleCalendar from 'flow/components/icons/GoogleCalendar';
import Outlook from 'flow/components/icons/Outlook';
import Teams from 'flow/components/icons/Teams';
import GoogleMeet from 'flow/components/icons/GoogleMeet';
import Zoom from 'flow/components/icons/Zoom';
import Office365 from 'flow/components/icons/Office365';
import AddReaction from 'flow/components/icons/AddReaction';
import TurnLeft from 'flow/components/icons/TurnLeft';
import TextColorLetter from 'flow/components/icons/TextColorLetter';
import Reload from 'flow/components/icons/Reload';
import ImageView from 'flow/components/icons/ImageView';
import LogOut from 'flow/components/icons/LogOut';
import VoicemailBox from 'flow/components/icons/VoicemailBox';
import GlobeQuestion from 'flow/components/icons/GlobeQuestion';
import CalendarAddOnIcon from 'flow/components/icons/CalendarAddOnIcon';

const icons = {
    'not-interested': NotInterested,
    'omni-queue': OmniQueue,
    'omni-queue-inverted': OmniQueueInverted,
    accessTime: AccessTime,
    account: Person,
    accountBox: AccountBox,
    accountCircle: AccountCircle,
    adminPanelSettingsOutlined: AdminPanelSettingsOutlined,
    add: Add,
    addBox: AddBox,
    addNote: NoteAdd,
    addNoteOutlined: NoteAddOutlined,
    addReaction: AddReaction,
    adminPanelSettings: AdminPanelSettings,
    archive: Archive,
    arrow_back: ArrowBack,
    arrow_down: ArrowDropDown,
    arrow_forward: ArrowForward,
    arrow_right: ArrowRight,
    article: Article,
    articleOutlined: ArticleOutlined,
    assign_to_me: AssignToMe,
    assign_to_other: AssignToOther,
    assignee: AssignmentInd,
    assigneeOutlined: AssignmentIndOutlined,
    assignment: Assignment,
    assignmentOutlined: AssignmentOutlined,
    assignmentComplete: AssignmentTurnedIn,
    assignmentCompleteOutlined: AssignmentTurnedInOutlined,
    assignmentLateOutlined: AssignmentLateOutlined,
    assignmentReturnOutlined: AssignmentReturnOutlined,
    attachment: AttachFile,
    autoFixWand: AutoFixWand,
    avg: Avg,
    bankid: Bankid,
    barChart: BarChart,
    borderColorOutlined: BorderColorOutlined,
    bottombar_inverted: BottombarInverted,
    business: Business,
    calendar: Today,
    calendarAddOn: CalendarAddOnIcon,
    call: Call,
    callOutlined: CallOutlined,
    callHistory: History,
    history: History,
    call_end: CallEnd,
    call_end_outlined: CallEndOutlined,
    call_to_action: CallToAction,
    callerid: CallMade,
    calls: Calls,
    chat: Chat,
    chat_outlined: ChatOutlined,
    chatBubble: ChatBubble,
    chat_member: People,
    chat_member_add: PersonAdd,
    check: Check,
    check_box_outline_blank: CheckBoxOutlineBlank,
    checkCircleOutline: CheckCircleOutline,
    chevron_left: ChevronLeft,
    chevron_right: ChevronRight,
    close: Close,
    contacts: Contacts,
    controlPoint: ControlPoint,
    copy: Copy,
    copyOutlined: CopyOutlined,
    create_contact: PermContactCalendar,
    crop_32: Crop32,
    delete: DeleteForever,
    description: DescriptionOutlined,
    dialpad: Dialpad,
    done: Done,
    download: GetApp,
    dragHandle: DragHandle,
    drive: GoogleDriveIcon,
    edit: Edit,
    email: Mail,
    emailOutlined: MailOutlined,
    emoji: InsertEmoticon,
    error: ErrorOutline,
    errorFilled: Error,
    extension: Extension,
    favorite_outline: StarBorder,
    file: InsertDriveFile,
    flow_admin: OpenInNew,
    formatBold: FormatBold,
    textColorLetter: TextColorLetter,
    formatItalic: FormatItalic,
    formatListBulleted: FormatListBulleted,
    formatListNumbered: FormatListNumbered,
    formatUnderlined: FormatUnderlined,
    forum: Forum,
    frejaeid: Frejaeid,
    fullscreen: Fullscreen,
    fullscreen_exit: FullscreenExit,
    fullscreen_inverted: FullscreenInverted,
    general: Settings,
    get_app: GetApp,
    widgets: WidgetsOutlined,
    google: GoogleIcon,
    gppGood: GppGood,
    group: Group,
    headset: HeadsetMic,
    hearing: Hearing,
    hour_glass_full: HourglassFull,
    image: Image,
    incoming: CallReceived,
    info: Info,
    invite: PersonAdd,
    ivr: Ivr,
    key: VpnKey,
    launch: Launch,
    label: Label,
    leave: LeaveRoomIcon,
    link: Link,
    lock: Lock,
    lockOpen: LockOpen,
    lockOutlined: LockOutlined,
    logOut: LogOut,
    lookUp: LookUp,
    loop: Loop,
    merge_call: CallMerge,
    message: Message,
    message_outline: MessageOutlined,
    message_post: Post,
    mic: Mic,
    mic_outlined: MicOutlined,
    mic_off: MicOff,
    microsoft: MicrosoftIcon,
    minimize: Minimize,
    missedCalls: CallMissed,
    mitid: Mitid,
    mobile: Smartphone,
    more_horiz: MoreHoriz,
    more_vert: MoreVert,
    movie: Movie,
    noMeetingRoom: NoMeetingRoom,
    notifications: Notifications,
    notifications_active: NotificationsActive,
    notificationsOff: NotificationsOff,
    outgoing: CallMade,
    openInNew: OpenInNew,
    pause: Pause,
    postAddOutlined: PostAddOutlined,
    pause_circle_outline: PauseCircleOutline,
    pending_icon: PendingIcon,
    pendingOutlined: PendingOutlined,
    people: People,
    percent: Percent,
    person: Person,
    personOutline: PersonOutline,
    phone: Phone,
    phone_in_talk: PhoneInTalk,
    phone_callback: PhoneCallback,
    photo_filter: BackgroundReplace,
    picture_in_picture_alt: PictureInPictureAlt,
    play_arrow: PlayArrow,
    play_circle_outline: PlayCircleOutline,
    present: PresentToAll,
    privacyTipOutlined: PrivacyTipOutlined,
    profiles: Tonality,
    public: MeetingRoom,
    push_pin: PushPinIcon,
    keep_off: KeepOffIcon,
    person_add: PersonAdd,
    queuelogin: People,
    quick_response: QuickReply,
    radio_button_unchecked: RadioButtonUnchecked,
    replay: Replay,
    report: Report,
    report_problem: ReportProblem,
    right_panel: RightPanel,
    right_panel_inverted: RightPanelInverted,
    ring_volume: RingVolume,
    screen_share: ScreenShare,
    screen_share_outlined: ScreenShareOutlined,
    search: Search,
    send_message: Send,
    setting_menu: Tune,
    settingsInputHdmi: SettingsInputHdmi,
    share: ShareOutlined,
    shared: CloudQueue,
    show_more: ChevronRight,
    sms: Textsms,
    softphone: SettingsPhone,
    star: Star,
    stop: Stop,
    subject: Subject,
    success: CheckCircle,
    supervisor: RemoveRedEye,
    supervisorCircle: SupervisedUserCircle,
    support_agent: SupportAgent,
    swapCalls: SwapCalls,
    swapHorizOutlined: SwapHorizOutlined,
    summarize: Summarize,
    telavox: Telavox,
    thumbUp: ThumbUp,
    thumbUp_outline: ThumbUpOutlined,
    timelapse: Timelapse,
    timer: TimerOutlined,
    toggle_call: Autorenew,
    transfer_call: TransferCall,
    tune: Tune,
    text_snippet: TextSnippet,
    agent_remove: AgentRemove,
    unarchive: Unarchive,
    usage: ShowChart,
    video: Videocam,
    video_outlined: VideocamOutlined,
    videoCall: VideoCall,
    videocam_off: VideocamOff,
    visibility: Visibility,
    voicemail: Voicemail,
    voicemailBox: VoicemailBox,
    volumeOff: VolumeOff,
    wallboard: Dashboard,
    widget: Widget,
    notificationsNoneIcon: NotificationsNone,
    infoOutlinedIcon: InfoOutlined,
    supervisorAccountIcon: SupervisorAccount,
    addCallIcon: AddCall,
    cancel: Cancel,
    addPhotoAlternateIcon: AddPhotoAlternate,
    callMissedOutgoing: CallMissedOutgoing,
    backspace: Backspace,
    simCard: SimCard,
    highPriority: PriorityHigh,
    DropZoneIcon: CloudUpload,
    SentimentSatisfiedAlt: SentimentSatisfiedAlt,
    whatsapp: WhatsApp,
    checkboxUnChecked: CheckboxUnchecked,
    checkboxChecked: CheckboxChecked,
    GoogleCalendar: GoogleCalendar,
    Office365: Office365,
    Outlook: Outlook,
    Teams: Teams,
    googleMeet: GoogleMeet,
    zoom: Zoom,
    turnLeft: TurnLeft,
    addThread: AddComment,
    viewThreads: Comment,
    reply: Reply,
    Equalizer: Equalizer,
    reload: Reload,
    imageView: ImageView,
    autoAwesome: AutoAwesome,
    globeQuestion: GlobeQuestion,
};

export type IconKey = keyof typeof icons;

const ICON_KEYS: ReadonlySet<string> = new Set(Object.keys(icons));

export const isIconKey = (key: unknown): key is IconKey =>
    typeof key === 'string' && ICON_KEYS.has(key);

export interface IconProps {
    className?: string;
    style?: React.CSSProperties;
    label?: string;
    size?: string;
    iconKey: IconKey;
}

const Icon = ({
    iconKey,
    label = '',
    className = '',
    style = {},
    size = '1.5rem',
}: IconProps) => {
    // iconKey can come from data at runtime, e.g. an unknown channel type.
    if (!isIconKey(iconKey)) {
        if (process.env.NODE_ENV !== 'production') {
            console.error(`Icon: no icon for iconKey "${iconKey}"`);
        }
        return null;
    }

    return React.createElement(icons[iconKey], {
        className: twMerge(
            className,
            ['send_message'].includes(iconKey) ? 'rtl:scale-x-[-1]' : '',
        ),
        // An icon is decorative by default: hidden from assistive tech so a
        // labelled parent (a button, a link) isn't announced twice. Passing a
        // `label` opts out of that and makes the icon itself the accessible
        // name — `aria-hidden` has to go with it, or the label is unreachable
        // (aria-hidden wins over aria-label on the same element).
        //
        // `aria-hidden: false` rather than omitting the key: both underlying
        // implementations set `aria-hidden="true"` *before* spreading props
        // through (MUI's SvgIcon, and our own icons/SvgIcon.tsx), so the key
        // has to be present to override their default.
        ...(label
            ? { role: 'img', 'aria-label': label, 'aria-hidden': false }
            : { 'aria-hidden': true }),
        style: { ...style, fontSize: size },
    });
};

export default Icon;
